import { FC } from 'react';
import { makeStyles, Typography } from '@material-ui/core'; 
import { Colors } from '../controls/helpers';

export const Section: FC<{ hideBottomBorder?: boolean, hideTopBorder?: boolean }> = ({ children, hideBottomBorder, hideTopBorder }) => {
    const classes = useStyles();
    return <div style={{ padding: '0 20px 10px' }}>
        <div
            className={classes.section}
            style={{
                borderBottom: hideBottomBorder ? 'unset' : '',
                paddingBottom: !hideBottomBorder ? 10 : 0,
                borderTop: hideTopBorder ? 'unset' : '',
                paddingTop: !hideTopBorder ? 10 : 0
            }}>
            {children}
        </div>
    </div>
}

export const Details: FC<{ title?: string, elevateTitle?: boolean }> = ({ children, elevateTitle, title}) => {
    const classes = useStyles();
    return <div style={{ display: 'flex' }}>
        {title && <Typography variant="subtitle1" className={classes.title} style={{ fontWeight: elevateTitle ? 500 : 400 }}>{title}</Typography>}
        {children}
    </div>
}

export const DetailText = ({ text }: { text?: string }) => <Typography variant="subtitle1" style={{ fontWeight: 500, paddingRight: 5 }}>{text || ''}</Typography>;

const useStyles = makeStyles({
    section: {
        borderTop: `1px solid ${Colors.Grey}`,
        borderBottom: `1px solid ${Colors.Grey}`,
        paddingTop: 10
    },
    title: {
        flexGrow: 1,
        color: Colors.Black,
        fontWeight: 400,
        margin: 'auto'
    }
}, { name: 'AdviserSection' });
